import React, { useEffect, useRef, useState } from 'react';
import * as Matter from 'matter-js';
import * as Tone from 'tone';
import AuthService from '../services/auth.service';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../app/store';
import { useNavigate } from 'react-router-dom';
import { showToast } from '../app/slice/toastsSlice';
import Loader from '../components/loader';
import { fetchWallet } from '../app/slice/walletSlice';
import $ from 'jquery';


type HistoryItem = {
    id: number;
    value: string;
};

const noteSets: Record<number, string[]> = {
    8: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4'],
    9: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4'],
    10: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4'],
    11: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4'],
    12: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4'],
    13: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4'],
    14: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3'],
    15: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3', 'A#3'],
    16: ['C#5', 'C5', 'B4', 'A#4', 'A4', 'G#4', 'G4', 'F#4', 'F4', 'E4', 'D#4', 'D4', 'C#4', 'C4', 'B3', 'A#3', 'A3'],
};

const pegSettings: Record<number, any> = {
    8: { GAP: 63, PEG_RAD: 7, BALL_RAD: 17, length: 90 },
    9: { GAP: 56, PEG_RAD: 7, BALL_RAD: 17, length: 110 },
    10: { GAP: 51, PEG_RAD: 7, BALL_RAD: 16, length: 120 },
    11: { GAP: 46, PEG_RAD: 7, BALL_RAD: 14, length: 135 },
    12: { GAP: 42, PEG_RAD: 6, BALL_RAD: 12, length: 150 },
    13: { GAP: 39, PEG_RAD: 6, BALL_RAD: 11, length: 150 },
    14: { GAP: 37, PEG_RAD: 5, BALL_RAD: 10, length: 170 },
    15: { GAP: 34, PEG_RAD: 4, BALL_RAD: 10, length: 180 },
    16: { GAP: 32, PEG_RAD: 3, BALL_RAD: 10, length: 180 },
};



type risk = 'low' | 'medium' | 'high';

const PlinkoGame: React.FC = () => {

    class Note {
        synth: Tone.PolySynth<Tone.Synth<Tone.SynthOptions>>;
        note: any;
        constructor(note: any) {
            this.synth = new Tone.PolySynth().toDestination();
            this.synth.set({ volume: -6 });
            this.note = note;
        }

        play() {
            return this.synth.triggerAttackRelease(
                this.note,
                '32n',
                Tone.context.currentTime
            );
        }

    }

    const canvasRef = useRef<HTMLCanvasElement>(null);
    const ballsRef = useRef<HTMLDivElement>(null);
    const [balls, setBalls] = useState(0);
    const [selectedRows, setSelectedRows] = useState<number>(8);
    const [isPageloading, setIsPageLoading] = useState(true);
    // const [multipliers, setMultiplierSets] = useState([3, 5, 6, 7, 8, 9, 5, 3]);
    const [multiplierSets, setMultiplierSets] = useState<Array<any> | any>();
    const [recentMultipliers, setRecentMultipliers] = useState<Array<number>>([]);
    const [riskLevel, setRiskLevel] = useState<risk>("low");
    const engine = useRef(Matter.Engine.create({ gravity: { scale: 0.0008 } }));
    const synthRef = useRef<Tone.NoiseSynth | null>(null);
    // const synthRef = useRef<Tone.NoiseSynth<Tone.Synth>>(new Tone.NoiseSynth(Tone.Synth).toDestination());
    const notesRef = useRef<string[]>([]);
    const funnelWalls = useRef<Matter.Body[]>([]);
    const animationRef = useRef<number | null>(null);
    const pegAnims = useRef<(number | null)[]>([]);
    const pegs = useRef<Matter.Body[]>([]);
    let BALL_RAD = useRef<number>(17);
    let GAP = pegSettings[selectedRows]?.GAP || 63;
    const currentEngine = engine.current;
    const [history, setHistory] = useState<HistoryItem[]>([]);
    const [animateIndex, setAnimateIndex] = useState<number | null>(null);
    let notes = noteSets[selectedRows].map((note) => new Note(note));
    const width = 620;
    const height = 525;
    let PEG_RAD = 8;
    const walletAmount = useSelector((state: RootState) => state.wallet.wallet);

    const [loading, setLoading] = useState(false);

    const [isAutoCall, setIsAutoCall] = useState<boolean>(false);
    const [betType, setBetType] = useState<any>('manual');
    const [betAmount, setBetAmount] = useState<number | any>("0");
    const [wallet, setWallet] = useState<any | Number>(walletAmount);
    const [isGameActive, setIsGameActive] = useState(false);
    const isStopped = useRef<boolean>(false);
    const autoDroppingInterval = useRef<NodeJS.Timeout | null>(null);
    const [noOfBet, setNoOfBet] = useState<number | any>(0);
    const [message, setMessage] = useState("");
    const [gameData, setGameData] = useState<any>({});
    const totalBallsToDropRef = useRef(0);
    const [droppedBallCount, setDroppedBallCount] = useState(0);
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();

    const BALL_CATEGORY = 0x0001;
    const PEG_CATEGORY = 0x0002;
    const WALL_CATEGORY = 0x0004;

    const dropBall = (ballId: number) => {
        if (!ballId) return;
        totalBallsToDropRef.current = totalBallsToDropRef.current + 1;
        // setTotalBallsToDrop((prev)=>prev+1);
        Matter.Engine.update(currentEngine, 1000 / 60);
        // setTimeout(() => {
        // await Tone.start();  
        const dropLeft = width / 2 - GAP;
        const dropRight = width / 2 + GAP;
        const x = Math.random() * (dropRight - dropLeft) + dropLeft;
        const y = -10;

        const ball = Matter.Bodies.circle(x, y, BALL_RAD.current, {
            label: 'Ball',
            restitution: 0.9,
            collisionFilter: {
                category: BALL_CATEGORY,
                mask: PEG_CATEGORY | WALL_CATEGORY, // only collide with pegs & walls
            },
            friction: 0.03,
            frictionAir: 0.03,
            id: ballId,
            render: {
                sprite: {
                    texture:
                        'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 13 12" fill="none"%3E%3Cellipse cx="6.5" cy="6" rx="5.91387" ry="5.91387" transform="rotate(-0.84069 6.5 6)" fill="url(%23paint0_radial_2657_4362)"/%3E%3Cellipse cx="6.50521" cy="6.05247" rx="4.30271" ry="4.30271" transform="rotate(-0.84069 6.50521 6.05247)" fill="url(%23paint1_radial_2657_4362)"/%3E%3Cpath d="M10.4075 5.99521C10.4391 8.15039 8.71765 9.92314 6.56247 9.95476C4.4073 9.98639 2.63454 8.26491 2.60292 6.10973C2.57129 3.95456 4.29277 2.18181 6.44795 2.15018C8.60312 2.11856 10.3759 3.84003 10.4075 5.99521Z" stroke="%2316171B" stroke-opacity="0.35" stroke-width="0.8"/%3E%3Cdefs%3E%3CradialGradient id="paint0_radial_2657_4362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.5 6) rotate(90) scale(5.91387)"%3E%3Cstop stop-color="%23FFE2C8"/%3E%3Cstop offset="0.9999" stop-color="%23FF912C"/%3E%3C/radialGradient%3E%3CradialGradient id="paint1_radial_2657_4362" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(6.50521 6.05247) rotate(90) scale(4.30271)"%3E%3Cstop stop-color="%23FFE2C8"/%3E%3Cstop offset="0.9999" stop-color="%23FF912C"/%3E%3C/radialGradient%3E%3C/defs%3E%3C/svg%3E',
                    xScale: BALL_RAD.current * 2 / 18, // since the SVG width is 18
                    yScale: BALL_RAD.current * 2 / 18, // match height too
                },

            },
        });

        synthRef.current?.triggerAttackRelease('32n', 0.5);
        // synthRef.current?.triggerAttackRelease('32n', Tone.context.currentTime === 0 ? 0.5 : Tone.context.currentTime);
        Matter.Composite.add(engine.current.world, [ball]);
        return () => {
            synthRef.current?.dispose(); // Dispose of the synth when the component unmounts
        };
        // }, 50);
    };

    function resetWorld() {
        Matter.Composite.clear(engine.current.world, false);
        Matter.Events.off(currentEngine, 'collisionStart');
        // pegs.current.forEach(peg => {
        //     Matter.Composite.remove(currentEngine.world, peg);
        // });
        if (animationRef.current) cancelAnimationFrame(animationRef.current);
        pegs.current = [];
        pegAnims.current = [];
    }

    function updateMultipliers(multipliers: any) {
        multipliers.forEach((m: any, i: any) => {
            const el = document.getElementById(`note-${i}`);
            if (el) el.innerHTML = m >= 1000 ? '1k' : (m > 99 && m < 1000) ? m : m + 'x';
        });
        for (let i = 0; i < 17; i++) {
            const el = document.getElementById(`note-${i}`);
            if (el) el.style.display = i < multipliers.length ? 'block' : 'none';
        }
    }

    function checkCollision(event: any, label1: any, label2: any, callback: any) {
        event.pairs.forEach(({ bodyA, bodyB }: any) => {
            let body1, body2;
            if (bodyA.label === label1 && bodyB.label === label2) {
                body1 = bodyA;
                body2 = bodyB;
            } else if (bodyA.label === label2 && bodyB.label === label1) {
                body1 = bodyB;
                body2 = bodyA;
            }
            if (body1 && body2) {
                callback(body1, body2);
            }
        });
    }

    useEffect(() => {

        resetWorld();
        synthRef.current = new Tone.NoiseSynth({ volume: -26 }).toDestination();
        notes = noteSets[selectedRows].map((note) => new Note(note));

        createTriangleFunnels(selectedRows);
        createPegs(selectedRows);
        if (multiplierSets) {
            let multiplier = multiplierSets[selectedRows as keyof typeof multiplierSets];
            updateMultipliers(multiplier[riskLevel as keyof typeof multiplier]);
        }
        const render = Matter.Render.create({
            canvas: canvasRef.current!,
            engine: currentEngine,
            options: {
                width: width,
                height: height,
                wireframes: false,
            },
        });

        Matter.Render.run(render);
        const runner = Matter.Runner.create();
        Matter.Runner.run(runner, currentEngine);

        // Create ground
        const ground = Matter.Bodies.rectangle(310, 547, 1240, 40, {
            isStatic: true,
            label: 'Ground',
            collisionFilter: {
                category: WALL_CATEGORY,
                mask: BALL_CATEGORY,
            },
        });

        Matter.Composite.add(currentEngine.world, [ground]);

        // Notes
        const noteList = noteSets[selectedRows] || [];
        notesRef.current = noteList;

        // Collision Logic
        Matter.Events.on(currentEngine, 'collisionStart', (event) => {
            checkCollision(event, 'Ball', 'Ground', (ballToRemove: any) => {
                Matter.Composite.remove(engine.current.world, ballToRemove);
                if (multiplierSets) {
                    let multiplier = multiplierSets[selectedRows as keyof typeof multiplierSets];
                    const multiplierArr = multiplier[riskLevel as keyof typeof multiplier];
                    const index = Math.floor((ballToRemove.position.x - width / 2) / GAP + multiplierArr?.length / 2);

                    if (index >= 0 && index < multiplierArr?.length) {
                        setBalls((prev) => prev + 1);
                        const el = document.getElementById(`note-${index}`);

                        if (el && el.dataset.pressed !== 'true' && notes[index] && typeof notes[index]?.play === 'function') {
                            const note = notes[index];
                            note.play();
                            el.dataset.pressed = 'true';
                            // el.dataset.value = String(multiplierArr[index]);
                            // console.log(multiplierArr[index], balls);
                            updatedWinMultiplier(multiplierArr[index], ballToRemove?.id);

                            setDroppedBallCount(prev => {
                                const updated = prev + 1;
                                // ✅ All balls dropped?
                               
                                if (updated === totalBallsToDropRef.current) {
                                    setIsGameActive(false);
                                }
                                return updated;
                            });

                            setRecentMultipliers((prev) => [multiplierArr[index], ...prev].slice(0, 4));

                            setTimeout(() => {
                                el.dataset.pressed = 'false';
                                el.dataset.value = "";

                            }, 500);
                        }

                    }

                }
            });

            checkCollision(event, 'Peg', 'Ball', (pegToAnimate: any) => {
                if (!pegToAnimate || !pegToAnimate.id) return;

                const index = pegs.current.findIndex((peg) => peg.id === pegToAnimate.id);
                if (index === -1) return;
                if (!pegAnims.current[index]) {
                    pegAnims.current[index] = new Date().getTime();
                }

            });

        });

        // Animation Loop        
        animate();

        // Cleanup
        return () => {
            Matter.Render.stop(render);
            Matter.Runner.stop(runner);
            Matter.World.clear(currentEngine.world, false);
            Matter.Engine.clear(currentEngine);
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };
    }, [selectedRows, riskLevel, multiplierSets]);


    const animate = () => {
        const ctx = canvasRef.current!.getContext('2d');
        const now = Date.now();
        pegAnims.current.forEach((time, index) => {
            if (!time || !ctx) return;
            const delta = now - time;
            if (delta > 1200) {
                pegAnims.current[index] = null;
                return;
            }

            const peg = pegs.current[index];
            const progress = 1 - Math.abs((delta / 1200) * 2 - 1);
            const radius = progress * 15;

            ctx.fillStyle = '#fff2';
            ctx.beginPath();
            ctx.arc(peg.position.x, peg.position.y, radius, 0, 2 * Math.PI);
            ctx.fill();
        });

        // Matter.Engine.update(currentEngine, 1000 / 60);
        animationRef.current = requestAnimationFrame(animate);
    };

    const createTriangleFunnels = (numRows: number) => {
        // Remove old walls
        funnelWalls.current.forEach(wall => {
            Matter.Composite.remove(engine.current.world, wall);
        });
        funnelWalls.current = [];

        const { length } = pegSettings[numRows];
        const wallThickness = 10;
        const triangleTopY = 80;
        const triangleHeight = height - 30;
        const triangleWidth = width - 120;
        const triangleStartX = 125;
        const triangleEndX = width / 2.5 + triangleWidth / 2;
        const slope = triangleHeight / (triangleWidth / 2);
        const angle = Math.atan(slope);

        const leftWall = Matter.Bodies.rectangle(
            triangleStartX - wallThickness / 2,
            triangleTopY + triangleHeight / 2,
            triangleHeight + length,
            wallThickness,
            {
                isStatic: true,
                angle: -angle,
                label: 'LeftWall',
                collisionFilter: {
                    category: WALL_CATEGORY,
                    mask: BALL_CATEGORY,
                },
                render: { fillStyle: 'transparent' },
            }
        );

        const rightWall = Matter.Bodies.rectangle(
            triangleEndX + wallThickness / 2,
            triangleTopY + triangleHeight / 2,
            triangleHeight + length,
            wallThickness,
            {
                isStatic: true,
                angle: angle,
                label: 'RightWall',
                collisionFilter: {
                    category: WALL_CATEGORY,
                    mask: BALL_CATEGORY,
                },
                render: { fillStyle: 'transparent' },
            }
        );

        Matter.Composite.add(engine.current.world, [leftWall, rightWall]);
        funnelWalls.current.push(leftWall, rightWall);
    };

    useEffect(() => {
        if (recentMultipliers.length > 0) {
            setAnimateIndex(0);
        }
    }, [recentMultipliers]);


    useEffect(() => {
        setIsPageLoading(true);
        AuthService.plinkoMultipliers()
            .then(
                (response) => {
                    // console.log(response?.data?.plinko_multipliers); 
                    if (response.status === 200) {
                        setMultiplierSets(response?.data?.plinko_multipliers);

                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                console.log(message)

            }).finally(() => {
                setIsPageLoading(false);
            });
    }, []);

    function createPegs(numRows: any) {
        const settings = pegSettings[numRows] || { GAP: 30, PEG_RAD: 3, BALL_RAD: 6 };
        GAP = settings.GAP;
        PEG_RAD = settings.PEG_RAD;
        BALL_RAD.current = settings.BALL_RAD; // 👈 Update ball size

        if (pegs.current.length > 0) {
            // Composite.remove(engine.world, pegs);
            pegs.current.forEach(peg => {
                Matter.Composite.remove(currentEngine.world, peg);
            });
            pegs.current = [];
            pegAnims.current = [];
        }

        for (let r = 0; r < numRows; r++) {
            const pegsInRow = r + 3;
            for (let c = 0; c < pegsInRow; c++) {
                const x = width / 2 + (c - (pegsInRow - 1) / 2) * GAP;
                const y = GAP + r * GAP;
                const peg = Matter.Bodies.circle(x, y, PEG_RAD, {
                    isStatic: true,
                    label: 'Peg',
                    collisionFilter: {
                        category: PEG_CATEGORY,
                        mask: BALL_CATEGORY, // only collide with balls
                    },
                    render: { fillStyle: '#fff' },
                });
                pegs.current.push(peg);
                pegAnims.current.push(null);
            }
        }

        Matter.Composite.add(currentEngine.world, pegs.current);
    }

    const handleNoBetChange = (e: any) => {
        const inputValue = e.target.value;
        if (inputValue === "" || !isNaN(Number(inputValue))) {
            setNoOfBet(inputValue);
        }

    };

    const onChangeAmount = (e: any) => {
        if (!isNaN(e.target.value)) {
            setBetAmount(e.target.value);
        }
    };

    const handleAmountAdd = (event: any, amt: number) => {
        event.preventDefault();
        if (amt > wallet?.user_combined_wallet) {
            setBetAmount(wallet?.user_combined_wallet);
            return;
        }
        setBetAmount(Number(amt).toFixed(2));
    };

    function handleClickBetType(type: any) {
        setBetType(type);
    };


    function handlePlaceBet() {
        let formData = {
            rows: selectedRows,
            risk: riskLevel,
            amount: betAmount
        }
        setIsGameActive(true);
        AuthService.PlaceBetPlinko(formData)
            .then(
                (response) => {
                    // console.log(response.data);
                    if (response.status === 200) {
                        dispatch(fetchWallet());
                        setGameData(response.data);
                        dropBall(response.data?.betId);
                    } else {
                        if (response.status !== 204) {
                            setMessage(response?.message);
                            let toast = {
                                type: 'error',
                                title: 'Error',
                                message: response?.message
                            }
                            dispatch(showToast(toast));
                        }

                        setLoading(false);
                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                } else {
                    let toast = {
                        type: 'error',
                        title: 'Error',
                        message: message
                    }
                    dispatch(showToast(toast));
                    setLoading(false);
                }
            }).finally(() => {
                setLoading(false);
            });


    }

    const startAutoBet = () => {
        if (!isAutoCall) {
            setIsAutoCall(true);
        }
    };


    function stopAutoBet() {
        if (autoDroppingInterval.current) {
            clearInterval(autoDroppingInterval.current);
            autoDroppingInterval.current = null;
            setIsAutoCall(false);
        }
    } 

    useEffect(() => {
        // totalBallsToDropRef.current=0;
        // setDroppedBallCount(0);
        if (isAutoCall && !autoDroppingInterval.current) {
            let dropped = 0;
            autoDroppingInterval.current = setInterval(() => {
                setNoOfBet((prevCount: any) => {
                    if (prevCount === 0) return 0;

                    if (prevCount <= 1) {
                        if (autoDroppingInterval.current) {
                            clearInterval(autoDroppingInterval.current);
                            autoDroppingInterval.current = null;
                            setIsAutoCall(false);
                        }
                        return 0;
                    }
                    return prevCount - 1;

                });

                handlePlaceBet();
                dropped++;
            }, 1000);
        }

        return () => {
            if (autoDroppingInterval.current) {
                clearInterval(autoDroppingInterval.current);
                autoDroppingInterval.current = null;
            }
        };
    }, [isAutoCall]);

    const updatedWinMultiplier = (multiplier: number, ballId: number) => {

        let formData = {
            betId: ballId,
            multiplier: btoa(String(multiplier))
        }

        AuthService.plinkoCashout(formData)
            .then(
                (response) => {
                    if (response.status === 200) {
                        dispatch(fetchWallet());
                    } else {
                        setLoading(false);
                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);

                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                } else {
                    let toast = {
                        type: 'error',
                        title: 'Error',
                        message: message
                    }
                    dispatch(showToast(toast));
                    setLoading(false);
                }
            }).finally(() => {
                setLoading(false);
            });

    }
   
    return (
        <div className='container webMine plinkoGame'>
            {isPageloading && <Loader />}
            <div className="row aviagameBagk px-0 pt-0">
                <div className='plinkoGamepp p-0 pt-0'>
                    <div className="canvas-container">
                        <canvas ref={canvasRef} width={width} height={height} style={{ background: 'none' }} />
                        <ul className="plinkohist" style={{ flexDirection: 'column-reverse' }}>
                            {recentMultipliers?.map((item: any, index: any) => (
                                <li
                                    key={index}
                                    className={`${index === animateIndex ? 'animate-history' : ''}`}
                                    onAnimationEnd={() => {
                                        if (index === 0) setAnimateIndex(null);
                                        // $('.animate-history').removeClass('animate-history');                                                                               
                                    }}
                                >
                                    {item}x

                                </li>
                            ))}
                        </ul>
                        {/* <ul className="plinkohist">
                            {history.map((item: any) => (
                                <li
                                    key={item.id}
                                    className={`history-item ${animatedIds.has(item.id) ? 'animate' : ''
                                        }`}
                                    onAnimationEnd={() => {
                                        setAnimatedIds((prev) => {
                                            const updated = new Set(prev);
                                            updated.delete(item.id);
                                            return updated;
                                        });
                                    }}
                                >
                                    {item.value}
                                </li>
                            ))}
                        </ul> */}
                    </div>
                    <div className="notes">
                        <div className="note" id="note-0"></div>
                        <div className="note" id="note-1"></div>
                        <div className="note" id="note-2"></div>
                        <div className="note" id="note-3"></div>
                        <div className="note" id="note-4"></div>
                        <div className="note" id="note-5"></div>
                        <div className="note" id="note-6"></div>
                        <div className="note" id="note-7"></div>
                        <div className="note" id="note-8"></div>
                        <div className="note" id="note-9"></div>
                        <div className="note" id="note-10"></div>
                        <div className="note" id="note-11"></div>
                        <div className="note" id="note-12"></div>
                        <div className="note" id="note-13"></div>
                        <div className="note" id="note-14"></div>
                        <div className="note" id="note-15"></div>
                        <div className="note" id="note-16"></div>
                    </div>
                </div>
            </div>
            <div className='row bg-dark-Bet'>
                <div className="tab-content" id="pills-tabContent">
                    <div className="col-12 betSelection mb-my webMineTab">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
                            </li>
                        </ul>
                    </div>
                    <div className="tab-pane fade show active" id="pills-ManualBet" role="tabpanel" aria-labelledby="pills-ManualBet-tab">
                        <div className="row">
                            <div className="col-12 mb-my mt-2">
                                <label htmlFor='amount'>Amount</label>
                                <div className='amountInpunt'>
                                    <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                                        <p>₹</p>
                                        <input type="text" id="amount" placeholder="enter amount" value={betAmount} onChange={(e) => onChangeAmount(e)} maxLength={10} autoComplete="off" readOnly={loading || isGameActive || isAutoCall} />
                                    </div>
                                    <div className='d-flex align-items-center justify-content-end' style={{ height: '100%', width: '100%' }}>
                                        <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount / 2) : undefined} disabled={loading || isGameActive || isAutoCall}>1/2</button>
                                        <button onClick={!isGameActive ? event => handleAmountAdd(event, betAmount * 2) : undefined} disabled={loading || isGameActive || isAutoCall}>2x</button>
                                        <button onClick={!isGameActive ? event => handleAmountAdd(event, wallet?.user_combined_wallet) : undefined} disabled={loading || isGameActive || isAutoCall}>All In</button>

                                    </div>
                                </div>
                            </div>
                            <div className="col-6 mb-my">
                                <label htmlFor='risk-level'>Risk</label>
                                <div className="custom-select">
                                    <select id="risk-level" aria-label="Default select example" defaultValue={riskLevel} onChange={(e) => (setRiskLevel((e.target.value as risk)))} disabled={loading || isGameActive || isAutoCall}>
                                        <option value="low">Low</option>
                                        <option value="medium">Medium</option>
                                        <option value="high">High</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-6 mb-my">
                                <label htmlFor='rows'>Row </label>
                                <div className="custom-select">
                                    <select id="rows" aria-label="Row selection" defaultValue={selectedRows} onChange={(e) => (setSelectedRows(Number(e.target.value)))} disabled={loading || isGameActive || isAutoCall}>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                    </select>
                                </div>
                            </div>

                            {betType === 'auto' ?
                                <>
                                    <div className="col-12 mb-my">
                                        <label>No. of Bets</label>
                                        <div className='amountInpunt'>
                                            <div className='d-flex align-items-center' style={{ height: '100%', width: '100%' }}>
                                                <input type="number" id="no_of_bet" value={noOfBet} onChange={handleNoBetChange} autoComplete='off' min={0} readOnly={isAutoCall} />
                                            </div>
                                            <div className='d-flex align-items-center justify-content-end' style={{ height: '100%' }}>
                                                <button style={{ background: 'none' }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                        <path d="M3 12C3 10.067 4.567 8.5 6.5 8.5C7.7035 8.5 8.51959 8.9338 9.19914 9.61336C9.9255 10.3397 10.4851 11.3322 11.1258 12.4856L11.1595 12.5462C11.7605 13.6283 12.4431 14.8573 13.3866 15.8009C14.3946 16.8088 15.7035 17.5 17.5 17.5C20.5376 17.5 23 15.0376 23 12C23 8.96243 20.5376 6.5 17.5 6.5C15.8394 6.5 14.3508 7.2359 13.3423 8.39937C13.7887 9.05406 14.1574 9.70577 14.464 10.2574C15.0681 9.20718 16.2014 8.5 17.5 8.5C19.433 8.5 21 10.067 21 12C21 13.933 19.433 15.5 17.5 15.5C16.2965 15.5 15.4804 15.0662 14.8009 14.3866C14.0745 13.6603 13.5149 12.6678 12.8742 11.5144L12.8405 11.4538C12.2395 10.3717 11.5569 9.14265 10.6134 8.19914C9.60541 7.1912 8.2965 6.5 6.5 6.5C3.46243 6.5 1 8.96243 1 12C1 15.0376 3.46243 17.5 6.5 17.5C8.16056 17.5 9.64923 16.7641 10.6577 15.6006C10.2113 14.9459 9.84262 14.2942 9.53605 13.7426C8.93194 14.7928 7.79856 15.5 6.5 15.5C4.567 15.5 3 13.933 3 12Z" fill="white" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 mb-my mt-2">
                                        {isAutoCall ?

                                            <button className='betBtn' onClick={!loading ? () => stopAutoBet() : undefined} disabled={loading}>
                                                {loading ?
                                                    <>
                                                        Please wait...
                                                    </>
                                                    :
                                                    <>
                                                        Stop Auto Bet
                                                    </>
                                                }
                                            </button>

                                            :
                                            <button className='betBtn' onClick={!loading ? () => startAutoBet() : undefined} disabled={betAmount === '' || loading ? true : false}>
                                                {loading ?
                                                    <>
                                                        Please wait...
                                                    </>
                                                    :
                                                    <>
                                                        Start Auto Bet
                                                    </>
                                                }
                                            </button>
                                        }
                                    </div>
                                </>
                                :

                                betType === 'manual' &&
                                <div className="col-12 mb-my mt-2">
                                    <button className='betBtn' onClick={!loading ? handlePlaceBet : undefined} disabled={loading || betAmount === '' ? true : false}>
                                        {loading ?
                                            <>
                                                Please wait...
                                            </>
                                            :
                                            <>
                                                Bet
                                            </>
                                        }
                                    </button>
                                </div>
                            }

                        </div>
                    </div>
                    <div className="col-12 betSelection mb-my">
                        <ul className="nav nav-pills" id="pills-tab" role="tablist">
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link${betType === 'manual' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('manual') : undefined}>Manual Bet</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`nav-link${betType === 'auto' ? ' active' : ''}`} type="button" role="tab" onClick={!isGameActive ? () => handleClickBetType('auto') : undefined}>Auto Bet</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default PlinkoGame;
